<a>
  <div class="child-box">
    <span>
      <em *ngIf="truncate" class="text-truncate">{{ truncate }}</em>{{ title }}</span>
      <fa-icon [icon]="icon"></fa-icon>
  </div>
</a>
